import socket from './socket';

const getMonthlyReport = (pointSystemId, data, headers) =>
  socket.get(`/point-systems/${pointSystemId}/monthly-report`, data, headers);

export default {
  getMonthlyReport,
};

